import Accordion from '@/common/components/Accordion'
import SelectController from '@/common/components/SelectController'
import { usePrinterMachines } from '@/common/hooks/queries/usePrinterMachines'
import useDebounce from '@/common/hooks/useDebounce'
import { Mapper } from '@/common/services/mapper'
import { PrinterMachineData } from '@/common/types/printerMachine.type'
import { PublicCompanyLeadsFunnelUpdateValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { BaseSyntheticEvent } from 'react'
import { useFormContext } from 'react-hook-form'

interface PrinterMachineInformationSectionProps {
  printerMachine?: PrinterMachineData
  submit?: (e?: BaseSyntheticEvent) => Promise<void>
  disabled?: boolean
}

export const PrinterMachineInformationSection = ({
  printerMachine,
  submit,
  disabled,
}: PrinterMachineInformationSectionProps) => {
  const [searchPrinterMachine, setSearchPrinterMachine] = useDebounce('')

  const {
    control,
    formState: { errors },
  } = useFormContext<PublicCompanyLeadsFunnelUpdateValidationSchema>()

  const { data: printerMachines } = usePrinterMachines({
    filters: {
      search: searchPrinterMachine,
    },
    mapper: Mapper.mapToOptions<PrinterMachineData>({ labelFieldName: 'display_name', valueFieldName: 'id' }),
  })

  return (
    <Accordion
      className="py-1"
      contentClassName="overflow-visible"
      defaultOpen
      head={
        <p>
          Detalhes para impressão de cartão <span className="text-danger-soft"> *</span>
        </p>
      }
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="printer_machine_id"
            label="Impressora padrão de cartões"
            triggerOnChange={submit}
            isDisabled={disabled}
            options={printerMachines}
            defaultValue={printerMachine ? { label: printerMachine.display_name, value: printerMachine.id } : undefined}
            onInputChange={setSearchPrinterMachine}
            errorMessage={errors?.printer_machine_id?.message}
          />
        </div>
      }
    />
  )
}
